module.exports = __webpack_public_path__ + "static/media/UP-TURN-mobile.76407191.webp";